if (!customElements.get('cart-recommendations')) {
  class CartRecommendations extends HTMLElement {
    connectedCallback() {
      this.version = 0;
      this.cartForm = document.getElementById('AjaxCartForm');
      this.signature = this.cartSignature();
      this.onCartChange = () => {
        const signature = this.cartSignature();
        if (signature !== this.signature) {
          this.signature = signature;
          clearTimeout(this.refreshTimer);
          this.refreshTimer = setTimeout(() => this.generateRecommendations(), 100);
        }
      };
      if (this.cartForm) {
        this.observer = new MutationObserver(this.onCartChange);
        this.observer.observe(this.cartForm, {childList: true, subtree: true});
        this.cartForm.addEventListener('cart-updated', this.onCartChange);
      }
      if (!this.querySelector('[data-df-extras-content]')) this.generateRecommendations();
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.cartForm?.removeEventListener('cart-updated', this.onCartChange);
      clearTimeout(this.refreshTimer);
      this.controller?.abort();
    }
    cartSignature() {
      return Array.from(document.querySelectorAll('#AjaxCartForm [data-js-cart-item]'))
        .map(item => `${item.dataset.productId}:${item.querySelector('.qty')?.value || ''}`).join('|');
    }
    async generateRecommendations() {
      this.controller?.abort();
      this.controller = new AbortController();
      const version = ++this.version;
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.set('section_id', this.dataset.section);
      try {
        const response = await fetch(url, {signal: this.controller.signal});
        if (!response.ok) return;
        const html = await response.text();
        const content = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-df-extras-content]');
        if (!content || version !== this.version || !this.isConnected) return;
        const restoreFocus = this.contains(document.activeElement);
        this.innerHTML = content.outerHTML;
        if (restoreFocus) this.querySelector('h2')?.focus({preventScroll: true});
      } catch (error) {
        if (error.name !== 'AbortError') this.dispatchEvent(new Event('cart-extras-error'));
      }
    }
  }
  customElements.define('cart-recommendations', CartRecommendations);
  customElements.define('df-cart-extras', class extends CartRecommendations {});
}
